import { Box, Button } from '@palmetto/palmetto-components';
import { FormikErrors, FormikValues, useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';

import { Flag, QueueStatus, QueueType } from 'types';

import { ReviewPackageActions } from '../../types/ReviewPackage';
import { useIsOrgReadOnly } from '../auth/claimsUtils';
import { CompleteQueueReview } from '../Queues/CompleteQueueReview/CompleteQueueReview';

interface ActionListFooterProps {
  isLoading: boolean;
  canSubmitPackage: boolean;
  canSubmitReview: boolean;
  disableApproval?: boolean;
  disableAllApprovals?: boolean;
  disabled?: boolean;
  onSave: ({ accountId, data }: { accountId: string; data: FormikValues }) => Promise<void>;
  actionButtonText?: string;
  conditionallyApprovedFlags?: Flag[];
  subQueueInfo?: {
    type: QueueType | undefined;
    status: QueueStatus | undefined;
  };
}
export const ActionListFooter = ({
  isLoading,
  canSubmitPackage,
  canSubmitReview,
  disableApproval,
  disableAllApprovals,
  onSave,
  disabled,
  actionButtonText,
  conditionallyApprovedFlags,
  subQueueInfo,
}: ActionListFooterProps) => {
  const { id = '', action = 'review' } = useParams<{ id: string; action: ReviewPackageActions }>();
  const { isSubmitting, errors, values, setSubmitting, touched } = useFormikContext<any>();

  const allowsAction = useIsOrgReadOnly();

  const handleSave = async () => {
    setSubmitting(true);
    await onSave({ accountId: id, data: values });
    setSubmitting(false);
  };

  const formErrors = Object.keys(errors).reduce((acc: FormikErrors<any>, key: string) => {
    const errorVal = touched[key] ? { [key]: errors[key] } : {};
    return {
      ...acc,
      ...errorVal,
    };
  }, {});

  return (
    <Box direction={'column'} childGap="sm" padding={'0'} alignItems={'flex-end'}>
      {action === ReviewPackageActions.review ? (
        <CompleteQueueReview
          canSubmitReview={canSubmitReview}
          disableApproval={disableApproval}
          disableAllApprovals={disableAllApprovals}
          handleFormSave={handleSave}
          conditionallyApprovedFlags={conditionallyApprovedFlags}
          subQueueInfo={{ type: subQueueInfo?.type, status: subQueueInfo?.status }}
        />
      ) : (
        <Button
          size="md"
          variant="primary"
          type="submit"
          isLoading={isSubmitting || isLoading}
          disabled={
            !canSubmitPackage || !!Object.keys(formErrors).length || disabled || isSubmitting || !allowsAction
          }
        >
          {actionButtonText}
        </Button>
      )}
    </Box>
  );
};
